// NOTE: Added lots of comments as this is quite complex
//       Follow steps for adding new event types
// ==============================
// EVENT TYPES & PAYLOADS
// ==============================

// [STEP 1]: Add new event type and payload here
// Defines the payload structure for each event type
export type AmplifyEventTypePayload = {
  CampaignViewConversation: {
    conversationId: string;
  };
  ConversationTyping: {
    words: string;
  };
};

// Union type of all possible event types
export type AmplifyEventType = keyof AmplifyEventTypePayload;

// ==============================
// EVENT STRUCTURES
// ==============================

// Base structure for all Amplify events
export interface AmplifyEvent<T extends AmplifyEventType = AmplifyEventType> {
  eventType: T;
  userId: string;
  payload: AmplifyEventTypePayload[T];
}

// Extends the base event structure with expiry time
export interface EventPayloadWithExpiry<
  T extends AmplifyEventType = AmplifyEventType
> extends AmplifyEvent<T> {
  expiryTime: number;
}

// ==============================
// CHANNEL CONFIGURATION
// ==============================

// [STEP 2]: Add new event type and parameters here
// Parameters required to create a channel for each event type
export type AmplifyChannelCreatorParams = {
  CampaignViewConversation: { campaignId: string };
  ConversationTyping: { conversationId: string };
};

// Map of functions that create channel names for each event type
export type AmplifyChannelCreators = {
  [K in AmplifyEventType]: (args: AmplifyChannelCreatorParams[K]) => string;
};

// ==============================
// CHANNEL CREATORS
// ==============================

// [STEP 3]: Add new event type and channel name creator here
// Functions to create channel names for each event type
export const amplifyChannelNameCreators: AmplifyChannelCreators = {
  CampaignViewConversation: ({ campaignId }) =>
    `/default/campaigns/${campaignId}`,
  ConversationTyping: ({ conversationId }) =>
    `/default/conversations/${conversationId}`
};

// ==============================
// TIMING CONFIGURATION
// ==============================

// [STEP 4]: Add expiry time
// Expiry times
export const amplifyChannelEventExpiryTime: {
  [K in AmplifyEventType]: number;
} = {
  CampaignViewConversation: 1000 * 3, // 3 seconds
  ConversationTyping: 1000 * 3 // 3 seconds
};
